export function visibleQuantityProductTile() {
  const searchResultContainer = document.getElementsByClassName('search-results')[0];
  const recommendationsContainer = document.getElementsByClassName('recommendations')[0];
  return !!$('#homepage').length || !!$('.cart-page').length || !!searchResultContainer || !!recommendationsContainer;
}
